import React from 'react';
import { IJobPostConfigProps } from './interfaces';
import { JobPostConfigContainer } from './containers';

export const JobPostConfig = (props: IJobPostConfigProps) => {
  return <JobPostConfigContainer {...props} />;
};

export default JobPostConfig;